import $ from '@rover/globals/jquery';
import Backbone from '@rover/globals/backbone';

export default Backbone.Model.extend({
  url() {
    if (this.instanceUrl) {
      return this.instanceUrl;
    }
    return this.get('url');
  },
  initialize(options) {
    this.instanceUrl = options.instanceUrl;
    if (this.get('expiration_year')) {
      this.setExpired();
    } else {
      this.on('sync', this.setExpired, this);
    }
  },
  setExpired() {
    this.set(
      'expired',
      $.payment.validateCardExpiry(this.get('expiration_month'), this.get('expiration_year')) ===
        false
    );
  },
  isNew() {
    return false;
  },
});



// WEBPACK FOOTER //
// ./js/backbone/models/CreditCardModel.js